import { useState } from 'react';
import { Game } from './components/Game';
import { MainMenu } from './components/MainMenu';
import { GameOver } from './components/GameOver';

const SCREEN = {
    MENU: 'menu',
    GAME: 'game',
    GAME_OVER: 'game_over'
};

const styles = {
    container: {
        height: '100dvh', // Use dynamic viewport height for mobile
        minHeight: '-webkit-fill-available',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #1e293b 0%, #581c87 50%, #1e293b 100%)',
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        overflow: 'hidden',
        position: 'fixed',
        top: 0,
        left: 0,
        paddingBottom: 'env(safe-area-inset-bottom, 0px)',
    },
    gameWrapper: {
        width: '100%',
        maxWidth: '400px',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        overflow: 'hidden',
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        backdropFilter: 'blur(10px)',
    }
};

export const AddemNumbersGame = () => {
    const [screen, setScreen] = useState(SCREEN.MENU);
    const [lastGameState, setLastGameState] = useState(null);

    const handleStartGame = () => {
        setScreen(SCREEN.GAME);
    };

    const handleGameOver = (finalState) => {
        setLastGameState(finalState);
        setScreen(SCREEN.GAME_OVER);
    };

    const handleBackToMenu = () => {
        setScreen(SCREEN.MENU);
    };

    const handleRestart = () => {
        setScreen(SCREEN.GAME);
    };

    return (
        <div style={styles.container}>
            <div style={styles.gameWrapper}>
                {screen === SCREEN.MENU && <MainMenu onStart={handleStartGame} />}
                {screen === SCREEN.GAME && <Game onGameOver={handleGameOver} />}
                {screen === SCREEN.GAME_OVER && lastGameState && (
                    <GameOver 
                        score={lastGameState.score} 
                        maxRange={lastGameState.range.max}
                        onRestart={handleRestart}
                        onHome={handleBackToMenu}
                    />
                )}
            </div>
        </div>
    );
};
